import React, { useState } from "react";
import LendyIcon from "../../components/lendy/LendyIcon";
import { toDocBlocks } from "./docText";

/** What a document is for, behind a small "What's this?" so the document comes first. */
export const AboutFile = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <aside className="lendy-doc-about">
      <button type="button" className="lendy-doc-about-toggle" aria-expanded={isOpen} onClick={() => setIsOpen((open) => !open)}>
        <LendyIcon name="info" size={14} />
        What's this?
      </button>
      {isOpen && <p>{children}</p>}
    </aside>
  );
};

/** A document read-only: headings with their bullets; an empty section says so. */
const DocView = ({ markdown, emptyText = "Nothing here yet." }) => (
  <div className="lendy-doc">
    {toDocBlocks(markdown).map((block, index) => {
      if (block.type === "paragraph") {
        return <p key={index}>{block.text}</p>;
      }
      return (
        <section key={index}>
          {block.text && <h3>{block.text}</h3>}
          {block.items.length ? (
            <ul>
              {block.items.map((item, itemIndex) => (
                <li key={itemIndex}>{item}</li>
              ))}
            </ul>
          ) : (
            <p className="lendy-doc-empty">{emptyText}</p>
          )}
        </section>
      );
    })}
  </div>
);

export default DocView;
